import { render, staticRenderFns } from "./ResultKraComponent.vue?vue&type=template&id=661a98cc"
import script from "./ResultKraComponent.vue?vue&type=script&lang=js"
export * from "./ResultKraComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports